<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <span v-for="message in messages" class="help-block"><strong>{{message}}</strong></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Errors",
        props: {
            messages: Array
        }
    }
</script>

<style scoped>

</style>